<h1 class="mb-4">Szczegóły wniosku</h1>

<p-tabs value="0" lazy [class]="'customTab'">
  <p-tablist>
    <p-tab value="0">Formularz wniosku</p-tab>
    <p-tab value="1">Historia zdarzeń</p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel value="0">
      @if (applicationForm()) {
        <app-application-form-details
          [applicationForm]="applicationForm()!"
        ></app-application-form-details>
      }
    </p-tabpanel>
    <p-tabpanel value="1">
      <app-application-history></app-application-history>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
